import PAText from "component/design-system/typography/PAText/PAText";
import styles from "./productDescription.module.scss";

const EachAttribute = (props: any) => {
  const { title, value } = props;
  return (
    <div className="d-flex align-items-center">
      <span className={styles.color_grey}>
        {title}
        :
      </span>
      <PAText component="h5" bold className="p-l-5 m-t-0 m-b-0" color="grey">{value}</PAText>
    </div>
  );
};

export default EachAttribute;
